import { shallowMount } from "@vue/test-utils";
import AddressSelector from "@/components/core/custom/AddressSelector";

describe("AddressSelector component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(AddressSelector);
  });

  it("Renders del component AddressSelector", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
